export const upperCaseFirstchart = (txt: string): string =>
  txt.replace(/^./, txt[0]?.toUpperCase());
